import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Versão: deploy v6 (network fix)
const buildVersion = 'v6-20250608';
console.log('GasNaPorta Entregador', buildVersion);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
